/* CLICK PRIMA IMMAGINE SCHEDA DETTAGLIO */
const firstMedia = document.querySelector('.media-thumbs__item .media-thumbs__btn.media');

if (firstMedia) {
  setTimeout(() => {
    firstMedia.click();
  }, 50); 
}

/* HEADER ACCOUNT CUSTOM */
setTimeout(function () {
  
    var customerPortalIframe = document.getElementById('customerPortalIframe');
    var mainContentAccount = document.getElementById('main-content');

    if (customerPortalIframe && mainContentAccount) {
        const headerAccount = `
            <header id="account" class="header" style="padding: 20px; background: #f5f5f5; display: flex; justify-content: space-between; align-items: center; border-bottom: none; padding-bottom: 24px;">
                <div class="logo">
                    <img src="https://shop.udibox.it/cdn/shop/files/logo-udibox.svg?v=1742219840&width=400" alt="UDIBOX Logo" style="height: 70px;" />
                </div>
                <a target="_blank" rel="noopener noreferrer" href="https://shop.udibox.it" class="btn btn--primary w-full" style="width:140px; padding: 10px 20px; color: #fff; text-decoration: none; border-radius: 5px;">Vai al sito</a>
            </header>
        `;
        mainContentAccount.insertAdjacentHTML('afterbegin', headerAccount);
    }   
  
}, 500);

/*  FORM ISCRIZIONE */
setTimeout(function () {
  
  const vatInput = document.getElementById('vat-validation');
  
  if (vatInput) {
    
    vatInput.value = 'IT';

    vatInput.addEventListener('input', function () {
      const cleaned = this.value.replace(/[^0-9]/g, '');
      this.value = 'IT' + cleaned;
    });

    vatInput.addEventListener('keydown', function (e) {
      if ((this.selectionStart <= 2) && (e.key === 'Backspace' || e.key === 'Delete')) {
        e.preventDefault();
      }
      
      if ((this.selectionStart <= 2) && (e.key.length === 1 && !/[0-9]/.test(e.key))) {
        e.preventDefault();
      }
    });
  }

}, 1000);

/*  PRODOTTI PERSONALIZZATI IMG */
setTimeout(function () {
  
  const slideHomeFormImg = document.querySelectorAll('.quick-nav__img-thumb img');
  const customSnackbarImg = document.querySelectorAll('.sticky-atc-panel img');

  if(slideHomeFormImg) {
   slideHomeFormImg.forEach((img) => {
      if (window.currentCustomerId && img.src.includes('personalizzato')) {
        img.src = img.src.replace('.png', '-' + window.currentCustomerId + '.png');
      }
    });
  }

  if(customSnackbarImg) {
    customSnackbarImg.forEach((img) => {
      if (window.currentCustomerId && img.srcset.includes('personalizzato')) {
        img.src = img.src.replaceAll('.png', '-' + window.currentCustomerId + '.png');
        img.srcset = img.srcset.replaceAll('.png', '-' + window.currentCustomerId + '.png');
      }
    });
  }

}, 1200);


// ==============================
// START FUNZIONE PER MODIFICARE IN MODO DINAMICO IL PREZZO CAD. ALL INTERNO DELLA PAGINA PRODOTTO AL CAMBIARE DELLO SCAGLIONE  

(function () {
  'use strict';

  // ============================
  // CONFIGURAZIONE
  // ============================
  const SELECTORS = {
    mainPrice: '.bss-b2b-price-no-vat',
    tierTableAncestor: 'table, .bss-b2b-price-table, [class*="tier"]',
    stickyAncestor: '.card--sticky-atc',
    unitPriceContainer: '.unit-price',
    stableObserveTarget: '.product-info__price',
    quantityInput: 'input[name="quantity"]',
    stickyPriceEl: '.card--sticky-atc [bss-b2b-product-price]',
    stickyPanel: 'sticky-atc-panel'
  };

  // ============================
  // UTILITY
  // ============================
  function parseEuro(text) {
    if (!text) return null;
    const cleaned = text.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function formatEuro(value) {
    return value.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ============================
  // RICERCA ELEMENTI
  // ============================
  function findMainPriceEl() {
    const candidates = document.querySelectorAll(SELECTORS.mainPrice);
    for (const el of candidates) {
      const inTable = el.closest(SELECTORS.tierTableAncestor);
      const inSticky = el.closest(SELECTORS.stickyAncestor);
      if (!inTable && !inSticky) return el;
    }
    return null;
  }

  function findUnitPriceTextNode(container) {
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const isHidden = node.parentElement && node.parentElement.closest('.visually-hidden');
      if (/€\s*[\d.,]+/.test(node.nodeValue) && !isHidden) {
        return node;
      }
    }
    return null;
  }

  // ============================
  // SINCRONIZZAZIONE
  // ============================
  let ratio = null;
  let isSyncing = false;

  function syncPrices() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const mainPriceEl = findMainPriceEl();
      const qtyInput = document.querySelector(SELECTORS.quantityInput);
      const unitContainer = document.querySelector(SELECTORS.unitPriceContainer);

      if (!mainPriceEl || !qtyInput) return;

      const currentQty = parseInt(qtyInput.value, 10) || 1;
      const currentTotalPrice = parseEuro(mainPriceEl.textContent);
      if (currentTotalPrice === null) return;

      const currentPackPrice = currentTotalPrice / currentQty;

      // --- Prezzo unitario (cad.) ---
      if (unitContainer) {
        const unitTextNode = findUnitPriceTextNode(unitContainer);
        if (unitTextNode) {
          if (ratio === null) {
            const baseUnitPrice = parseEuro(unitTextNode.nodeValue);
            if (baseUnitPrice && baseUnitPrice > 0) {
              ratio = currentPackPrice / baseUnitPrice;
              console.log('[unit-price-sync] rapporto pezzi/confezione:', ratio);
            }
          }
          if (ratio) {
            const newUnitPrice = currentPackPrice / ratio;
            const formatted = formatEuro(newUnitPrice);
            const newValue = unitTextNode.nodeValue.replace(/€\s*[\d.,]+/, '€' + formatted);
            if (unitTextNode.nodeValue !== newValue) {
              unitTextNode.nodeValue = newValue;
            }
          }
        }
      }

      // --- Prezzo nella barra sticky ---
      const stickyPriceEl = document.querySelector(SELECTORS.stickyPriceEl);
      if (stickyPriceEl && stickyPriceEl.textContent.trim() !== mainPriceEl.textContent.trim()) {
        stickyPriceEl.innerHTML = mainPriceEl.innerHTML;
      }
    } finally {
      isSyncing = false;
    }
  }

  // ============================
  // OSSERVATORE (SENZA DEBOUNCE: correzione sincrona immediata)
  // ============================
  function initObserver() {
    const target = document.querySelector(SELECTORS.stableObserveTarget);
    const stickyPanel = document.querySelector(SELECTORS.stickyPanel);

    if (!target) {
      console.warn('[unit-price-sync] contenitore stabile non trovato, ritento tra 500ms');
      setTimeout(initObserver, 500);
      return;
    }

    syncPrices();

    // NIENTE setTimeout: la correzione avviene nello stesso ciclo
    // in cui il MutationObserver rileva il cambiamento, prima che
    // il browser disegni il fotogramma successivo.
    const observer = new MutationObserver(syncPrices);
    observer.observe(target, { childList: true, characterData: true, subtree: true });

    if (stickyPanel) {
      const stickyObserver = new MutationObserver(syncPrices);
      stickyObserver.observe(stickyPanel, { childList: true, characterData: true, subtree: true });
    }

    console.log('[unit-price-sync] observer attivo (correzione sincrona, senza debounce)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }
})();

// ====================
// END FUNZIONE
// ====================

// ====================
// START FUNZIONE PER MODIFICARE PREZZO NEL DRAWER DEL CARRELLO

(function () {
  'use strict';

  const SELECTORS = {
    rowSelector: 'tr.cart-item, [class*="cart-item"][id*="cart-item"]',
    linePrice: '.bss-b2b-price-no-vat',
    lineTotalExclude: '.cart-item__total',
    unitPriceContainer: '.custom-cart-prezzo-unitario'
  };

  function parseEuro(text) {
    if (!text) return null;
    const cleaned = text.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.');
    const value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function formatEuro(value) {
    return value.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function findUnitPriceLeaf(container) {
    const leafEls = container.querySelectorAll('*');
    for (const el of leafEls) {
      if (el.children.length === 0 && /\d/.test(el.textContent) && !el.className.includes('visually-hidden')) {
        return el;
      }
    }
    return /\d/.test(container.textContent) ? container : null;
  }

  function syncRow(row) {
    // Legge il numero di pezzi per confezione direttamente dal data-attribute
    // (stesso metafield già usato da Liquid), niente più fetch/rete.
    const qty = parseFloat(row.dataset.packageQty);
    if (!qty || qty <= 1) return;

    const priceEls = row.querySelectorAll(SELECTORS.linePrice);
    let priceEl = null;
    for (const el of priceEls) {
      if (!el.closest(SELECTORS.lineTotalExclude)) { priceEl = el; break; }
    }
    if (!priceEl) return;

    const unitContainer = row.querySelector(SELECTORS.unitPriceContainer);
    if (!unitContainer) return;
    const unitLeaf = findUnitPriceLeaf(unitContainer);
    if (!unitLeaf) return;

    const currentPrice = parseEuro(priceEl.textContent);
    if (currentPrice === null) return;

    const newUnitPrice = currentPrice / qty;
    const formatted = formatEuro(newUnitPrice);
    const newText = unitLeaf.textContent.replace(/[\d.,]+/, formatted);
    if (unitLeaf.textContent.trim() !== newText.trim()) {
      unitLeaf.textContent = newText;
    }
  }

  function syncAllCarts() {
    document.querySelectorAll(SELECTORS.rowSelector).forEach(syncRow);
  }

  function initCartObserver() {
    syncAllCarts();

    const observer = new MutationObserver(() => {
      clearTimeout(window.__cartUnitPriceSyncTimeout);
      window.__cartUnitPriceSyncTimeout = setTimeout(syncAllCarts, 150);
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });

    console.log('[cart-unit-price-sync] observer attivo sul documento (senza fetch)');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartObserver);
  } else {
    initCartObserver();
  }
})();

// FINE FUNZIONE PER MODIFICARE PREZZO NEL DRAWER DEL CARRELLO
// ====================